import React from "react";
import { ResultDisplayPage as PageType, UserProfile } from "../../types/quiz";
import { getBMICategory } from "../../utils/quizLogic";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  userProfile: UserProfile;
  onNext: () => void;
}

const ResultDisplayPage: React.FC<Props> = ({ page, userProfile, onNext }) => {
  return (
    <div className="page page--result-display">
      <div className="page__container">
        <h2 className="page__question">{page.title}</h2>

        <div className="results">
          {page.results.map((result, index) => {
            // Handle BMI result
            if (result.type === "bmi" && userProfile.bmi) {
              const category = getBMICategory(userProfile.bmi);
              const interpretation = result.interpretation?.[category];

              return (
                <div key={index} className="result-card result-card--highlight">
                  <h3 className="result-card__label">{result.label}</h3>
                  <div className="result-card__bmi">
                    <div className="bmi-scale">
                      <div
                        className="bmi-scale__marker"
                        style={{
                          left: `${Math.min(100, (userProfile.bmi / 40) * 100)}%`,
                        }}
                      >
                        <span className="bmi-scale__value">
                          You - {userProfile.bmi}
                        </span>
                      </div>
                      <div className="bmi-scale__track"></div>
                      <div className="bmi-scale__labels">
                        <span>15</span>
                        <span>18.5</span>
                        <span>25</span>
                        <span>30</span>
                        <span>40</span>
                      </div>
                    </div>
                  </div>
                  {interpretation && (
                    <div
                      className="result-card__interpretation"
                      style={{
                        backgroundColor: interpretation.color + "20",
                        borderColor: interpretation.color,
                      }}
                    >
                      <span className="result-card__icon">
                        {interpretation.icon}
                      </span>
                      <div>
                        <h4 style={{ color: interpretation.color }}>
                          {interpretation.title}
                        </h4>
                        <p>{interpretation.text}</p>
                      </div>
                    </div>
                  )}
                </div>
              );
            }

            // Handle other result types
            const displayValue = result.value?.replace(
              /\{(\w+)\}/g,
              (_, key) => userProfile[key] || "",
            );

            return (
              <div key={index} className="result-card">
                {result.icon && (
                  <span className="result-card__icon">{result.icon}</span>
                )}
                <div>
                  <h3 className="result-card__label">{result.label}</h3>
                  <p className="result-card__value">{displayValue}</p>
                </div>
              </div>
            );
          })}
        </div>

        {page.image && (
          <img src={page.image} alt="Results" className="results__image" />
        )}

        <button className="page__button" onClick={onNext}>
          {page.buttonText}
        </button>
      </div>
    </div>
  );
};

export default ResultDisplayPage;
